import React from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { loginSetFlowStageWatcher } from "../../redux/actions/loginactioncreators";
import { NewFADVLoginForm } from "./NewFADVLoginForm";
import { LegacyLoginHelpLink } from "./LegacyLoginHelpLink";
import { SafeFormattedMessage } from "./SafeFormattedMessage";

export const SignUpExistingLogin = () => {
  const dispatch = useDispatch();
  const signupState = useSelector(state => state.loginForm.signup ?? {});
  const signupMessage = signupState.message ?? "";
  const helpLink = (
    // eslint-disable-next-line formatjs/no-literal-string-in-jsx
    <a href="https://help.fadv.com/" target="_blank" rel="noopener noreferrer" className="underline">help.fadv.com</a>
  );

  const handleCancel = () => {
    dispatch(loginSetFlowStageWatcher({ flowStage: "LOGIN" }));
  };

  return (
    <NewFADVLoginForm
      onSubmit={handleCancel}
      headerContent={<FormattedMessage id="signup.existingLogin" defaultMessage="You've already signed up" description="Header for the signup existing login page" />}
      submitButtonText={<FormattedMessage id="signup.returnToSignIn" defaultMessage="Return to sign in" description="Button text for redirecting to sign in" />}
      middleContent={<LegacyLoginHelpLink />}
      onEscapeKey={handleCancel}
    >
      {signupMessage ? (
        <p className="text-primary-fg text-base leading-6">
          {typeof signupMessage === "object" && signupMessage.id ? <SafeFormattedMessage {...signupMessage} values={{ ...signupMessage.values, helpLink }} /> : signupMessage}
        </p>
      ) : (
        <p className="text-primary-fg text-base leading-6">
          <FormattedMessage
            id="signup.existingLoginBlurb"
            defaultMessage="It looks like there are already login credentials associated with this EA account or email. Please sign in instead of signing up."
            description="Instructional text shown when signup finds an existing login for the user"
          />
        </p>
      )}
    </NewFADVLoginForm>
  );
};